var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 35H9.5C8.30653 35 7.16193 34.5259 6.31802 33.682C5.47411 32.8381 5 31.6935 5 30.5V6.5C5 6.10218 5.15804 5.72064 5.43934 5.43934C5.72064 5.15804 6.10218 5 6.5 5H27.5C27.8978 5 28.2794 5.15804 28.5607 5.43934C28.842 5.72064 29 6.10218 29 6.5V24.5H35V30.5C35 31.6935 34.5259 32.8381 33.682 33.682C32.8381 34.5259 31.6935 35 30.5 35ZM29 27.5V30.5C29 30.8978 29.158 31.2794 29.4393 31.5607C29.7206 31.842 30.1022 32 30.5 32C30.8978 32 31.2794 31.842 31.5607 31.5607C31.842 31.2794 32 30.8978 32 30.5V27.5H29ZM26 32V8H8V30.5C8 30.8978 8.15804 31.2794 8.43934 31.5607C8.72064 31.842 9.10218 32 9.5 32H26ZM11 12.5H23V15.5H11V12.5ZM11 18.5H23V21.5H11V18.5ZM11 24.5H18.5V27.5H11V24.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.9172243b94a524375deaf5e71c5d40e3.svg";
export { ForwardRef as ReactComponent };